import { Grid, TextField } from '@material-ui/core';
import React from 'react';
import { DynamicFieldProps } from './types';


const NumericTextField = (props: DynamicFieldProps) => {
  const { field,mandatory} = props;
  const [value, setValue] = React.useState(props.value);
  return (
    <Grid item md={props.width} xs={12}>
      <TextField
        inputRef={props.reference}
        aria-readonly={field.ReadOnly}
        disabled={field.ReadOnly}
        error={field.Error}
        type="number"
        style={props.style}
        id={field.Name}
        label={field.Label}
        required={mandatory}
        onChange={e => {
          setValue(e.target.value);
          props.formValueChanged && props.formValueChanged(field.Name, e.target.value);
        }}
        value={value || props.value}
      />
    </Grid>
  );
};

export default NumericTextField;